import {createSvgIcon} from '../create-svg-icon';

export const PaddingIcon = createSvgIcon(
  <path d="M3 5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm16 14H5V5h14v14zM11 7h2v2h-2V7zM7 7h2v2H7V7zm8 0h2v2h-2V7z" />
, 'PaddingOutlined');
